import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { Product } from '../_types/product';
import { ProductsService } from '../_services/products.service';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-products-detail',
    templateUrl: './products-detail.component.html',
    styleUrls: ['./products-detail.component.scss'],
    standalone: false
})
export class ProductsDetailComponent {
  public productFormGroup!: RxFormGroup;

  public product: Product = new Product();

  public allowWrite: boolean = false;

  constructor(
    private productsService: ProductsService,
    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService
  ) {

    this.productFormGroup = this.formBuilder.formGroup<Product>(this.product) as RxFormGroup;

    //el modulo es informativo: se muestra pero no se puede modificar
    this.productFormGroup.get('module')?.disable();
  }

  async ngOnInit() {
    let id = this.config.data.id;
    if (id != null && id != '0') {
      this.loadProduct(id);
    }

    this.allowWrite = this.loginService.hasPermission("PRODUCTS.WRITE");
  }

  async loadProduct(id: string) {
    this.product = await firstValueFrom(this.productsService.get(id));
    this.productFormGroup.patchValue(this.product);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.productFormGroup);
    if (valid) {
      this.product = Object.assign(this.product, this.productFormGroup.value);
      await firstValueFrom(this.productsService.save(this.product));
      this.messageService.add({ closable: true, severity: 'success', summary: "Precio guardado correctamente." });
      this.cancel();
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  cancel() {
    this.dynamicDialogRef.close();
  }

}
